import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { BASE_URL, AUTH } from "../config/axios";
import Dashboardnavbar from "../layout/Dashboardnavbar";

const ACTION_COLORS = {
  CREATE_SUBCOMPANY: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_SUBCOMPANY: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_SUBCOMPANY: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_DIVISION: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_DIVISION: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_DIVISION: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_PROJECT_DETAILS: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_PROJECT_DETAILS: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  UPDATE_PROJECT_PAYMENT: { bg: "#e3f2fd", color: "#1565c0", label: "Payment" },
  DELETE_PROJECT_DETAILS: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_PROJECT: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_PROJECT: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  UPDATE_PAYMENT: { bg: "#e3f2fd", color: "#1565c0", label: "Payment" },
  DELETE_PROJECT: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_SUBCONSULTANT: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_SUBCONSULTANT: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_SUBCONSULTANT: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_WORKSTATS: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_WORKSTATS: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_WORKSTATS: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_WORKTYPE: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_WORKTYPE: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_WORKTYPE: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  CREATE_SUBMISSION: { bg: "#e8f5e9", color: "#2e7d32", label: "Create" },
  UPDATE_SUBMISSION_STAGE: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_SUBMISSION: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  UPLOAD_DOCUMENT: { bg: "#f3e5f5", color: "#6a1b9a", label: "Upload" },
  UPDATE_DOCUMENT: { bg: "#fff3e0", color: "#e65100", label: "Update" },
  DELETE_DOCUMENT: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  BULK_UPLOAD_DOCUMENTS: { bg: "#f3e5f5", color: "#6a1b9a", label: "Bulk Upload" },
  BULK_CREATE_PROJECT: { bg: "#e8f5e9", color: "#2e7d32", label: "Bulk Create" },
  BULK_UPDATE_PROJECT: { bg: "#fff3e0", color: "#e65100", label: "Bulk Update" },
  BULK_DELETE_PROJECT: { bg: "#fce4ec", color: "#c62828", label: "Delete" },
  ASSIGN_DPR_ROLE: { bg: "#e8eaf6", color: "#283593", label: "Role" },
  UPDATE_DPR_ROLE: { bg: "#e8eaf6", color: "#283593", label: "Role" },
  DPR_LOGIN: { bg: "#f1f8e9", color: "#558b2f", label: "Login" },
};

const getActionStyle = (action) =>
  ACTION_COLORS[action] || { bg: "#f5f5f5", color: "#424242", label: action };

const formatTimestamp = (ts) => {
  const d = new Date(ts);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });
};

const formatRelativeTime = (date) => {
  if (!date) return "";
  const seconds = Math.floor((new Date() - date) / 1000);
  if (seconds < 5) return "just now";
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  return date.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });
};

const DetailsModal = ({ log, onClose }) => {
  if (!log) return null;
  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.4)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "28px",
          width: "520px",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1a1a2e" }}>Log Details</h3>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", fontSize: "20px", cursor: "pointer", color: "#666" }}
          >
            ×
          </button>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          <DetailRow label="User" value={log.email || "unknown"} />
          <DetailRow label="Role" value={log.role} />
          <DetailRow label="Action" value={log.action} />
          <DetailRow label="IP Address" value={log.ip || "N/A"} />
          <DetailRow label="Timestamp" value={formatTimestamp(log.timestamp)} />
          <div>
            <p style={{ fontSize: "12px", color: "#888", marginBottom: "6px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>Details</p>
            <pre
              style={{
                background: "#f8f9fa",
                borderRadius: "8px",
                padding: "12px",
                fontSize: "12px",
                color: "#333",
                overflowX: "auto",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                border: "1px solid #e9ecef",
              }}
            >
              {JSON.stringify(log.details, null, 2)}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

const DetailRow = ({ label, value }) => (
  <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
    <span style={{ fontSize: "12px", color: "#888", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px", minWidth: "90px" }}>
      {label}
    </span>
    <span style={{ fontSize: "13px", color: "#333", fontWeight: "500" }}>{value}</span>
  </div>
);

// Simple pulsing dot, no external CSS file needed
const LiveDot = ({ active }) => (
  <span
    style={{
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      background: active ? "#f9a825" : "#2e7d32",
      display: "inline-block",
      boxShadow: active ? "0 0 0 0 rgba(249,168,37,0.6)" : "0 0 0 0 rgba(46,125,50,0.5)",
      animation: active ? "dprPulse 1s ease-in-out infinite" : "none",
    }}
  />
);

const POLL_INTERVAL_MS = 10000; // 10s — tune based on load

const DPRAuditLogPage = () => {
  const [logs, setLogs] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading] = useState(true); // first load only
  const [refreshing, setRefreshing] = useState(false); // silent background poll
  const [lastUpdated, setLastUpdated] = useState(null);
  const [selectedLog, setSelectedLog] = useState(null);
  const [newCount, setNewCount] = useState(0);

  const [search, setSearch] = useState("");
  const [actionFilter, setActionFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");

  const prevIdsRef = useRef(new Set());
  const tickRef = useRef(null);

  const fetchLogs = async (isBackground = false) => {
    if (isBackground) setRefreshing(true);
    else setLoading(true);

    try {
      const res = await axios.get(`${BASE_URL}/dpr/audit-logs/`, AUTH());
      const data = res.data || [];

      if (isBackground && prevIdsRef.current.size > 0) {
        const freshCount = data.filter((l) => !prevIdsRef.current.has(l.id)).length;
        if (freshCount > 0) setNewCount((c) => c + freshCount);
      }

      prevIdsRef.current = new Set(data.map((l) => l.id));
      setLogs(data);
      setLastUpdated(new Date());
    } catch (err) {
      console.error("Failed to fetch audit logs", err);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  // Initial load + polling loop
  useEffect(() => {
    fetchLogs(false);

    tickRef.current = setInterval(() => {
      if (document.visibilityState === "visible") {
        fetchLogs(true);
      }
    }, POLL_INTERVAL_MS);

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        fetchLogs(true); // catch up immediately when tab regains focus
      }
    };
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      clearInterval(tickRef.current);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, []);

  // Filtering, unchanged in behavior
  useEffect(() => {
    let result = [...logs];
    if (search.trim()) {
      const s = search.toLowerCase();
      result = result.filter(
        (l) =>
          l.email?.toLowerCase().includes(s) ||
          l.action?.toLowerCase().includes(s) ||
          l.role?.toLowerCase().includes(s) ||
          JSON.stringify(l.details)?.toLowerCase().includes(s)
      );
    }
    if (actionFilter !== "all") {
      result = result.filter((l) => l.action === actionFilter);
    }
    if (roleFilter !== "all") {
      result = result.filter((l) => l.role === roleFilter);
    }
    setFiltered(result);
  }, [search, actionFilter, roleFilter, logs]);

  const uniqueActions = [...new Set(logs.map((l) => l.action))].sort();
  const uniqueRoles = [...new Set(logs.map((l) => l.role))].sort();

  const handleManualRefresh = () => {
    setNewCount(0);
    fetchLogs(true);
  };

  return (
    <>
      <style>{`
        @keyframes dprPulse {
          0% { box-shadow: 0 0 0 0 rgba(249,168,37,0.6); }
          70% { box-shadow: 0 0 0 6px rgba(249,168,37,0); }
          100% { box-shadow: 0 0 0 0 rgba(249,168,37,0); }
        }
      `}</style>

      <Dashboardnavbar name="Audit Log" url="Settings" />
      <div style={{ padding: "24px 30px" }}>

        {/* Header Stats */}
        <div style={{ display: "flex", gap: "16px", marginBottom: "16px", flexWrap: "wrap" }}>
          {[
            { label: "Total Logs", value: logs.length, color: "#2576BC" },
            { label: "Filtered", value: filtered.length, color: "#2e7d32" },
            { label: "Unique Users", value: new Set(logs.map((l) => l.email)).size, color: "#6a1b9a" },
            { label: "Actions Today", value: logs.filter((l) => new Date(l.timestamp).toDateString() === new Date().toDateString()).length, color: "#e65100" },
          ].map((s) => (
            <div
              key={s.label}
              style={{
                background: "#fff",
                border: "1px solid #e9ecef",
                borderRadius: "10px",
                padding: "16px 24px",
                minWidth: "140px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
              }}
            >
              <p style={{ fontSize: "11px", color: "#888", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>
                {s.label}
              </p>
              <p style={{ fontSize: "24px", fontWeight: "700", color: s.color }}>{s.value}</p>
            </div>
          ))}
        </div>

        {/* Live status bar */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "16px",
            fontSize: "12px",
            color: "#888",
          }}
        >
          <LiveDot active={refreshing} />
          <span>
            {refreshing
              ? "Syncing…"
              : lastUpdated
              ? `Live · updated ${formatRelativeTime(lastUpdated)}`
              : ""}
          </span>
          {newCount > 0 && (
            <span
              style={{
                background: "#e3f2fd",
                color: "#1565c0",
                borderRadius: "12px",
                padding: "2px 10px",
                fontWeight: "600",
                fontSize: "11px",
              }}
            >
              {newCount} new
            </span>
          )}
        </div>

        {/* Filters */}
        <div style={{ display: "flex", gap: "12px", marginBottom: "20px", flexWrap: "wrap", alignItems: "center" }}>
          <input
            type="text"
            placeholder="Search by user, action, role..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{
              padding: "8px 14px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "13px",
              minWidth: "260px",
              outline: "none",
              background: "#fff",
            }}
          />
          <select
            value={actionFilter}
            onChange={(e) => setActionFilter(e.target.value)}
            style={{
              padding: "8px 14px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "13px",
              background: "#fff",
              outline: "none",
              cursor: "pointer",
            }}
          >
            <option value="all">All Actions</option>
            {uniqueActions.map((a) => (
              <option key={a} value={a}>{a}</option>
            ))}
          </select>
          <select
            value={roleFilter}
            onChange={(e) => setRoleFilter(e.target.value)}
            style={{
              padding: "8px 14px",
              borderRadius: "8px",
              border: "1px solid #ddd",
              fontSize: "13px",
              background: "#fff",
              outline: "none",
              cursor: "pointer",
            }}
          >
            <option value="all">All Roles</option>
            {uniqueRoles.map((r) => (
              <option key={r} value={r}>{r}</option>
            ))}
          </select>
          <button
            onClick={handleManualRefresh}
            disabled={refreshing}
            style={{
              padding: "8px 18px",
              borderRadius: "8px",
              border: "none",
              background: "#2576BC",
              color: "#fff",
              fontSize: "13px",
              fontWeight: "600",
              cursor: refreshing ? "default" : "pointer",
              opacity: refreshing ? 0.7 : 1,
            }}
          >
            {refreshing ? "Refreshing…" : "Refresh"}
          </button>
        </div>

        {/* Table */}
        <div style={{ background: "#fff", borderRadius: "12px", border: "1px solid #e9ecef", overflow: "hidden", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#f8f9fa", borderBottom: "1px solid #e9ecef" }}>
                {["#", "Timestamp", "User (Email)", "Role", "Action", "Details Summary", "IP", ""].map((h) => (
                  <th
                    key={h}
                    style={{
                      padding: "12px 16px",
                      textAlign: "left",
                      fontSize: "11px",
                      fontWeight: "700",
                      color: "#888",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={8} style={{ padding: "48px", textAlign: "center", color: "#888", fontSize: "14px" }}>
                    Loading audit logs...
                  </td>
                </tr>
              ) : filtered.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ padding: "48px", textAlign: "center", color: "#888", fontSize: "14px" }}>
                    No logs found.
                  </td>
                </tr>
              ) : (
                filtered.map((log, idx) => {
                  const style = getActionStyle(log.action);
                  const detailSummary = log.details
                    ? Object.entries(log.details)
                        .slice(0, 2)
                        .map(([k, v]) => `${k}: ${typeof v === "object" ? "..." : v}`)
                        .join(" | ")
                    : "—";
                  return (
                    <tr
                      key={log.id}
                      style={{
                        borderBottom: "1px solid #f0f0f0",
                        transition: "background 0.15s",
                      }}
                      onMouseEnter={(e) => (e.currentTarget.style.background = "#f8faff")}
                      onMouseLeave={(e) => (e.currentTarget.style.background = "")}
                    >
                      <td style={{ padding: "12px 16px", fontSize: "12px", color: "#aaa" }}>{idx + 1}</td>
                      <td style={{ padding: "12px 16px", fontSize: "12px", color: "#555", whiteSpace: "nowrap" }}>
                        {formatTimestamp(log.timestamp)}
                      </td>
                      <td style={{ padding: "12px 16px", fontSize: "13px", color: "#333", fontWeight: "500" }}>
                        {log.email || "unknown"}
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <span
                          style={{
                            background: "#e8eaf6",
                            color: "#283593",
                            borderRadius: "6px",
                            padding: "3px 10px",
                            fontSize: "11px",
                            fontWeight: "600",
                            textTransform: "capitalize",
                          }}
                        >
                          {log.role}
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <span
                          style={{
                            background: style.bg,
                            color: style.color,
                            borderRadius: "6px",
                            padding: "3px 10px",
                            fontSize: "11px",
                            fontWeight: "600",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {log.action}
                        </span>
                      </td>
                      <td
                        style={{
                          padding: "12px 16px",
                          fontSize: "12px",
                          color: "#777",
                          maxWidth: "220px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {detailSummary}
                      </td>
                      <td style={{ padding: "12px 16px", fontSize: "12px", color: "#aaa" }}>{log.ip || "—"}</td>
                      <td style={{ padding: "12px 16px" }}>
                        <button
                          onClick={() => setSelectedLog(log)}
                          style={{
                            background: "none",
                            border: "1px solid #ddd",
                            borderRadius: "6px",
                            padding: "4px 10px",
                            fontSize: "11px",
                            color: "#2576BC",
                            cursor: "pointer",
                            fontWeight: "600",
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>

        <p style={{ marginTop: "12px", fontSize: "12px", color: "#aaa", textAlign: "right" }}>
          Showing {filtered.length} of {logs.length} logs (latest 500)
        </p>
      </div>

      {selectedLog && <DetailsModal log={selectedLog} onClose={() => setSelectedLog(null)} />}
    </>
  );
};

export default DPRAuditLogPage;